<template>
    <div class="content">
        <div class="hw-content">
            <div class="content-head-title">申请开票</div>
            <div class="mb20">
                <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="发票类型">
                        <div class="rows">
                            <el-select v-model="params.Invoice_Type" placeholder="请选择" class="el-select-medium">
                                <el-option v-for="item in Invoice_Type_List" :key="item.value" :label="item.name" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户名称">
                        <div class="rows">{{ orderInfo.Buyer_name || '--' }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="税号">
                        <div class="rows">{{ orderInfo.Buyer_tax_no || '--' }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="地址电话">
                        <div class="rows">{{ orderInfo.Buyer_addr_phone || '--' }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="开户账号">
                        <div class="rows">{{ orderInfo.Buyer_bank_accounts || '--' }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="客户类型">
                        <div class="rows">{{ orderInfo.typeset || '--' }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="申请人邮箱">
                        <div class="rows">{{ orderInfo.Apply_Email || '--' }}</div>
                    </el-descriptions-item>
                    <!-- <el-descriptions-item label="EMS Region">
                        <div class="rows">
                            <el-input v-model="params.Message" placeholder="请输入" clearable class="el-select-medium"></el-input>
                            <font style="color: #ff0000; margin-left: 5px">*</font>
                        </div>
                    </el-descriptions-item> -->
                    <el-descriptions-item label="注释">
                        <div class="rows">
                            <el-input v-model="params.Apply_remark" placeholder="请输入" clearable class="el-select-medium"></el-input>
                            <font style="color: #ff0000; margin-left: 5px" v-if="orderInfo.Apply_remark!=''">*</font>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div class="button-container">
                <el-button type="primary" @click="submit">已确认客户开票信息正确无误</el-button>
                <el-button @click="goBlack">取消</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            OrdersID: '',
            orderInfo: {
                Buyer_name: '', // 客户名称
                Buyer_tax_no: '', // 税号
                Buyer_addr_phone: '', // 地址电话
                Buyer_bank_accounts: '', // 开户账号
                typeset: '', // 客户类型
                Apply_Email: '', // 申请人邮箱
                Message: '', // EMS Region
                Apply_remark: '' // 注释
            },
            params: {
                Invoice_Type: '', // 发票类型
                Message: '', // EMS Region
                Apply_remark: '' // 注释
            },
            Invoice_Type_List: [] // 发票类型列表
        };
    },
    mounted() {
        const params = this.$route.query;
        if (params) {
            this.OrdersID = params.OrdersID;
            this.Office_CheckInvoiceApply();
        }
    },
    methods: {
        async Office_CheckInvoiceApply() {
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.Office_CheckInvoiceApply({
                OrdersID: this.OrdersID
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            let data = result.data.data;
            this.params = {
                Invoice_Type: Object.values(data.Invoice_Type)[0], // 发票类型
                Message: data.Message, // EMS Region
                Apply_remark: data.Apply_remark // 注释
            };
            let objArr = [];

            for (let key in data.Invoice_Type) {
                var obj = {};
                obj.name = key;
                obj.value = data.Invoice_Type[key];
                objArr.push(obj);
            }
            this.Invoice_Type_List = objArr;
            this.orderInfo = data;
        },
        async submit() {
            let json = {};
            json['Invoice_Type_' + this.OrdersID] = this.params.Invoice_Type;
            json['Apply_EMSRegion_' + this.OrdersID] = this.params.Message;
            json['Apply_remark_' + this.OrdersID] = this.params.Apply_remark;
            json = JSON.stringify(json);
            let result = await this.$newsApi.order.Orders_Invoice_Apply_Add({
                OrdersID: this.OrdersID,
                Json: json
            });
            if (result.data.Resultcode == 0) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$router.go(-1);
            }
        },
        goBlack() {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}


/* 通用样式 */
.rows {
    width: 389px;
}
.links {
    color: #409eff;
    cursor: pointer;
}
.red {
    color: #f56c6c;
    margin-right: 10px;
}
.distributeBox {
    /deep/.is-center,
    .el-table__cell {
        padding: 0;
    }
    /deep/.cell {
        padding: 0;
    }
}

.office-box {
    .no-border-table {
        border: none; /* 去掉表格的四周边框 */
    }

    .no-border-table .el-table__header,
    .no-border-table .el-table__body {
        border: none; /* 去掉表头和表体的边框 */
    }

    .no-border-table .el-table__row {
        border: none; /* 去掉表格行的边框 */
    }
    /deep/.is-center,
    /deep/.el-table__cell {
        height: 25px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.flex {
    display: flex;
    align-items: center;
}
.mb20 {
    margin-bottom: 20px;
}
.error {
    color: red;
    font-weight: 700;
    margin-bottom: 20px;
}
</style>